import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "wfp_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (line) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.variationId === line.variationId);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + (line.qty || 1) };
        return next;
      }
      return [...prev, { ...line, qty: line.qty || 1 }];
    });
    setOpen(true);
  };

  const updateQty = (variationId, qty) =>
    setItems((prev) =>
      prev
        .map((i) => (i.variationId === variationId ? { ...i, qty } : i))
        .filter((i) => i.qty > 0)
    );

  const removeItem = (variationId) =>
    setItems((prev) => prev.filter((i) => i.variationId !== variationId));

  const clear = () => setItems([]);

  const count = items.reduce((a, i) => a + i.qty, 0);
  const subtotal = items.reduce((a, i) => a + i.price * i.qty, 0);

  const value = useMemo(
    () => ({ items, addItem, updateQty, removeItem, clear, count, subtotal, open, setOpen }),
    [items, count, subtotal, open]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
